<template>
  <div class="d-flex flex-row align-items-start" style="gap: 10px;">
    <!-- Cart on the left -->
    <div class="trt-cart-wrapper" :style="kmzLoading ? { minHeight: '120px' } : {}">
      <div v-if="kmzLoading" class="kmz-loading-overlay">
        <b-spinner variant="light" label="Loading..." />
        <span class="kmz-loading-text">{{ kmzLoadingDone }} / {{ kmzLoadingTotal }} loaded</span>
      </div>
      <div class="trt-cart" :class="{ 'kmz-blurred': kmzLoading }" id="cart">
      <b-row class="w-100 trt-cart-header px-3 py-2" no-gutters>
        <b-col cols="2" class="d-flex justify-content-center align-items-center">
          <fa :icon="['fas', 'shopping-cart']" class="trt-header-icon" size="sm"/>
        </b-col>
        <b-col cols="9" class="d-flex justify-content-start align-items-center pl-2">
          <span class="trt-header-label">{{ cart.length }} Trail{{ cart.length == 1 ? '' : 's' }} Selected</span>
        </b-col>
        <b-col class="col-sm-1 d-flex justify-content-center align-items-center" v-if="cart.length">
          <fa
            class="float-right clickable"
            :title="
              cartMinimized ? 'Maximize Cart' : 'Minimize Cart'
            "b]
            :icon="[
              'fas',
              cartMinimized ? 'window-maximize' : 'window-minimize'
            ]"
            size="sm"
            @click="toggleCartSize()"
          />
        </b-col>
      </b-row>
      <div
        class="d-flex flex-column w-100 px-3 py-2 trt-cart-items"
        v-if="cart.length && !cartMinimized"
      >
        <div
          v-for="(cartItem, index) in cart"
          :key="cartItem.pc_id"
          class="w-100 d-flex justify-content-center align-items-center flex-row trt-cart-row"
          @mouseover="cartHoverIndex = index"
          @mouseleave="cartHoverIndex = null"
        >
          <b-button
            class="trt-cart-item w-100 text-truncate"
            :id="'cart-' + cartItem.pc_id"
            size="sm"
            variant="transparent"
            :title="cartItem.pc_id"
          >
            {{ cartItem.pc_id }}
          </b-button>
          <div
            class="d-flex justify-content-center align-items-center ml-1 trt-remove-wrap"
            v-if="cartHoverIndex == index"
          >
            <fa :icon="['fas', 'trash']" class="trt-remove-btn" @click="removeCartItem(cartItem)"></fa>
          </div>
        </div>
      </div>
      <b-row class="w-100 trt-actions px-2 pb-2" no-gutters v-if="cart.length && !cartMinimized">
        <b-col cols="10" class="d-flex justify-content-center align-items-center">
          <b-button
            :disabled="cart.length < 1"
            class="trt-stats-btn w-100"
            title="Show statistics for selected trails"
            id="lidarStatsBtn"
            @click="initStatsModal"
          >
            <fa :icon="['fas', 'chart-bar']" class="mr-2"></fa>
            Show Statistics
          </b-button>
        </b-col>
        <b-col cols="2" class="d-flex justify-content-center align-items-center">
          <fa
            :icon="['fa', 'trash']"
            class="trt-clear-btn"
            size="1x"
            @click="clearCart"
            title="Clear Selection"
            v-show="cart.length >= 1"
            id="clearTrailsBtn"
          ></fa>
        </b-col>
      </b-row>
      </div>
    </div>

    <!-- Modal -->
    <TRT_StatisticsWindow
      v-if="showTrailsPanel"
      :polygons="polygons"
      :lidar_wkt="lidar_wkt"
      :selectedExtent="selectedExtent"
      :user="user"
      :lidarFlag="lidarFlag"
      :cart="cart"
      :selectedTrails="selectedTrails"
      :map="map"
      @removePolygons="$emit('removePolygons')"
      @clearCart="$emit('clearCart')"
      @notification="$emit('notification', $event)"
      @admin-notification="$emit('admin-notification', $event)"
    ></TRT_StatisticsWindow>
  </div>
</template>

<style scoped>
.trt-cart-wrapper {
  position: relative;
}

.kmz-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(6, 60, 109, 0.6);
  backdrop-filter: blur(3px);
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 5px;
}

.kmz-loading-text {
  color: #fff;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.08em;
}

.kmz-blurred {
  pointer-events: none;
}

.trt-cart {
  width: 15rem;
  max-height: 60vh;
  background: #eef3f9;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  /* border: 1px solid rgba(6, 60, 109, 0.12); */
  box-shadow: 0 4px 20px rgba(6, 60, 109, 0.12);
  overflow: hidden;
  font-family: system-ui, -apple-system, sans-serif;
  color: #063c6d;
}

/* ── Header ─────────────────────────────────────────── */
.trt-cart-header {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 2;
  background: #063c6d;
  border-bottom: 1px solid rgba(6, 60, 109, 0.1);
}

.trt-header-label {
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.trt-header-icon {
  color: rgba(255, 255, 255, 1);
  /* font-size: 0.75rem; */
}

.trt-cart-header .clickable {
  color: rgba(255, 255, 255, 0.85) !important;
  font-size: 0.95rem;
}
.trt-cart-header .clickable:hover {
  color: #ffffff !important;
}

.trt-clear-btn {
  cursor: pointer;
  color: rgba(6, 60, 109, 0.8);
  transition: color 0.15s ease, transform 0.1s ease;
}

.trt-clear-btn:hover {
  color: #063c6d;
  transform: scale(1.15);
}

.trt-clear-btn:active {
  transform: scale(0.95);
}

/* ── Cart item list ──────────────────────────────────── */
.trt-cart-items {
  flex: 1;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(6, 60, 109, 0.25) transparent;
  gap: 0.25rem;
}

.trt-cart-items::-webkit-scrollbar {
  width: 4px;
}
.trt-cart-items::-webkit-scrollbar-track {
  background: transparent;
}
.trt-cart-items::-webkit-scrollbar-thumb {
  background: rgba(6, 60, 109, 0.22);
  border-radius: 2px;
}
.trt-cart-items::-webkit-scrollbar-button {
  display: none;
}

.trt-cart-row {
  min-height: 1.875rem;
}

.trt-cart-item {
  color: #063c6d !important;
  background: #fff !important;
  border: 1px solid rgba(6, 60, 109, 0.18) !important;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  padding: 0.1875rem 0.5rem;
}

.trt-cart-item:hover {
  color: #063c6d !important;
  background: rgba(6, 60, 109, 0.06) !important;
  border-color: rgba(6, 60, 109, 0.35) !important;
}

/* ── Remove icon ─────────────────────────────────────── */
.trt-remove-wrap {
  flex-shrink: 0;
}

.trt-remove-btn {
  cursor: pointer;
  color: rgba(255, 100, 100, 0.8);
  height: 0.875rem;
  transition: color 0.15s ease, transform 0.1s ease;
}

.trt-remove-btn:hover {
  color: #ff6b6b;
  transform: scale(1.15);
}

.trt-remove-btn:active {
  transform: scale(0.95);
}

/* ── Stats button ────────────────────────────────────── */
.trt-actions {
  flex-shrink: 0;
  padding-top: 0.375rem;
}

.trt-stats-btn {
  background: linear-gradient(135deg, #28a745, #1e7e34);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.4375rem 0.75rem;
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;
  box-shadow: 0 2px 6px rgba(30, 126, 52, 0.35);
}

.trt-stats-btn:not(:disabled):hover {
  background: linear-gradient(135deg, #1e7e34, #155724);
  box-shadow: 0 4px 10px rgba(30, 126, 52, 0.5);
  transform: translateY(-1px);
}

.trt-stats-btn:not(:disabled):active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(30, 126, 52, 0.3);
}

.trt-stats-btn:disabled {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: none;
  cursor: not-allowed;
  opacity: 0.5;
}
</style>

<script>
import MultiLineString from 'ol/geom/MultiLineString';
import WKT from 'ol/format/WKT';

// import DT_InformationModal from './DT_InformationModal.vue';
import TRT_StatisticsWindow from './TRT_StatisticsWindow.vue';

export default {
  name: "TRT_TrailsCart",
  props: [
    'cart',
    'selectedTrails',
    'map',
    'selectedExtent',
    'user',
    'showTrailsPanel',
    'lidarFlag',
    'polygonsSelected',
    'kmzLoadingTotal',
    'kmzLoadingDone'
  ],
  data() {
    return {
      lidar_wkt: [],
      cartHoverIndex: null,
      polygons: [],
      cartMinimized: false
    }
  },
  components: {
    TRT_StatisticsWindow
  },
  computed: {
    kmzLoading() {
      return this.kmzLoadingTotal > 0 && this.kmzLoadingDone < this.kmzLoadingTotal
    }
  },
  methods: {
    toggleCartSize() {
      this.cartMinimized = !this.cartMinimized
    },
    initStatsModal() {
      this.polygons = []
      if (this.polygonsSelected.length > 0) {
        const format = new WKT();
        this.polygons = [];
        let polyWKTS = [];

        for (const polygon of this.polygonsSelected) {
          const polygonWkt = format.writeGeometry(polygon.getGeometry(), {
            dataProjection: 'EPSG:4326',
            featureProjection: 'EPSG:3857'
          });

          polyWKTS.push(polygonWkt);
        }

        this.polygons = polyWKTS;
      }

      if (this.selectedTrails.length) {
        const lineGeoms = this.selectedTrails
          .map(f => f.getGeometry())
          .filter(Boolean);

        const multiLine = new MultiLineString(
          lineGeoms.map(g => g.getCoordinates())
        );

        const wkt = new WKT().writeGeometry(multiLine, {
          dataProjection: 'EPSG:4326',
          featureProjection: this.map.getView().getProjection()
        });

        this.lidar_wkt.pop();
        this.lidar_wkt.push(wkt);
      }

      this.$bvModal.show('TRTStatsModal');
    },
    clearCart() {
      this.$emit('clearCart');
      this.cartHoverIndex = null;
      this.$emit('clearPolygon');
    },
    removeCartItem(cartItem) {
      this.$emit('removeItem', cartItem);
      this.cartHoverIndex = null;
    }
  }
}
</script>
